import React, { useState, useRef, useEffect } from 'react'
import { ThreeBarsIcon } from '@primer/octicons-react'
import { Link } from 'gatsby'

const Menu = ({ menu = [{ name: 'Inicio', path: '/' }] }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const clickEnPagina = e => {
      if (dropdownRef.current !== null) {
        setOpen(!open)
      }
    }
    if (typeof window !== 'undefined') {
      if (open) {
        window.addEventListener('click', clickEnPagina)
      }
      return () => {
        window.removeEventListener('click', clickEnPagina)
      }
    }
  }, [open])

  const dropdownRef = useRef(null)

  return (
    <div className="relative text-right">
      <button
        aria-label="Menú"
        className="w-8 h-8 rounded-full"
        onClick={() => setOpen(!open)}>
        <ThreeBarsIcon className="text-white " size={16} />
      </button>
      {open && (
        <nav
          ref={dropdownRef}
          className="absolute right-0 z-30 w-48 mt-2 overflow-hidden bg-white rounded-md shadow-xl">
          {menu &&
            menu.map(item => {
              return (
                <Link
                  to={item.path}
                  className="block px-4 py-2 transition-all duration-500 ease-in-out border-gray-300 border-b-default hover:bg-gray-300"
                  key={item.name}>
                  {item.name}
                </Link>
              )
            })}
        </nav>
      )}
    </div>
  )
}

export default Menu
